/* eslint-disable import/default */

import 'url-search-params-polyfill';
import 'regenerator-runtime/runtime';
import React from 'react';
import { render } from 'react-dom';
import Modal from 'react-modal';
import { Provider } from 'react-redux';

import configureStore from './store/configureStore';
import App from './containers/App';
import { initFromDrupal, addSecurityPackageLink } from './actions/orderActions';
import {
  setOriginalAgencyInfo,
  customerLeave,
  hideAbandonBasket,
} from './actions/appearanceActions';
import './assets/styles/main.scss';
import scrollToInvalid from './assets/js/scroll-to-invalid';

if (document.getElementById('booking-wrap')) {
  const store = configureStore();

  // We send from backend flag to show abandon basket, for case of double opt in.
  store.dispatch(initFromDrupal());
  store.dispatch(hideAbandonBasket());
  store.dispatch(setOriginalAgencyInfo(store.getState().orderAppState.agency));
  store.dispatch(addSecurityPackageLink());
  const start = new Date();
  // Check if customer came from email than set to true.
  let showed =
    window.location.search.substring(1).search('utm_source=abandon') !== -1;

  document.addEventListener('mouseout',
    event => {
      const from = event.relatedTarget || event.toElement;
      if ((!from || from.nodeName === 'HTML') && event.clientY < 0 && false) {
        const end = new Date();
        if (
          end - start >= 5000 &&
        !showed
        ) {
          store.dispatch(customerLeave());
          showed = true;
        }
      }
    });

  const dispatchScrollToInvalid = scrollToInvalid({
    container: document.documentElement,
    focusSelector: '[class*="-input"]:not(div)',
    scrollToSelector:
      '.form-field--error, .Select--error, .final-cleaning--error',
  });

  render(
    <Provider store={store}>
      <App
        dispatchScrollToInvalid={dispatchScrollToInvalid}
        validatorFactory={
          () =>
            import(
              /* webpackChunkName: "validator" */
              /* webpackPreload: true */
              './validation/orderValidator'
            ).then(
              file =>
                // eslint-disable-next-line new-cap
                new file.default(
                  store.dispatch,
                  store.getState().appearanceAppState
                )
            ) // eslint-disable-line new-cap
        }
      />
    </Provider>,
    document.getElementById('booking-wrap')
  );

  Modal.setAppElement('#booking-wrap');
  import('./validation/orderValidator');
}
